// extracted by mini-css-extract-plugin
export var avatar = "_sh-3";
export var avatarContainer = "_sh-2";
export var avatarSpacer = "_sh-5";
export var avatarSpacerContainer = "_sh-4";
export var avatarStackContainer = "_sh-1";
export var bubble = "_sh-0";
export var remainderBubble = "_sh-6";